module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "PartsGrey_Icon.dd48ffa0.png";